export function scrollToSection(sectionId, { focusEmail = false } = {}) {
  const section = document.getElementById(sectionId);
  if (!section) return;

  section.scrollIntoView({ behavior: "smooth", block: "center" });

  if (focusEmail) {
    window.setTimeout(() => {
      document.getElementById("waitlist-email-input")?.focus({ preventScroll: true });
    }, 700);
  }
}
